export default __webpack_public_path__ + "assets/trinidadandtobago-flag.png";